module.exports = __webpack_public_path__ + "static/B1-650f8ee209d49bff865c657959617750.jpg";